module.exports = __webpack_public_path__ + "images/vehicle-point.8345b9d324a088750f75cd9179218efe.png";